// extracted by mini-css-extract-plugin
export default {"h1":"Auth_h1__FAX7Z","formContainer":"Auth_formContainer__xbIGV"};